// The plan's limits (David, 31 Oct: as much as possible for a paying account, at most about $1.20 a month on Cloudflare
// for each). The worker holds accounts to them (worker/workspace.ts LIMITS), Settings shows them and read_help says them,
// all from here. The site's docs, /ai-info/, llms.txt and pricing say the same numbers: change them together.

export const PLAN = {
  boards: 50,
  /** pages, rows, ideas, posts or deals a board holds */
  entriesPerBoard: 2000,
  /** pictures and files, in bytes */
  pictureBytes: 2_000_000_000,
  /** the boards' data, chats aside, in bytes */
  dataBytes: 2_000_000_000,
  /** chat history, in bytes */
  chatBytes: 1_000_000_000,
  /** pushes a day, from agents and scripts (push_data and the push address) */
  pushesPerDay: 5_000,
  /** source reads a day, every source's together */
  pullsPerDay: 6_000,
  /** rows written a month past which agents, scripts and sources slow: a soft cap */
  writesPerMonth: 1_000_000,
} as const;

/** A size as people read it: "2 GB", "340 MB", "12 KB". */
export function sizeWords(bytes: number): string {
  if (bytes >= 1e9) return `${Math.round((bytes / 1e9) * 10) / 10} GB`;
  if (bytes >= 1e6) return `${Math.round(bytes / 1e6)} MB`;
  return `${Math.max(0, Math.round(bytes / 1e3))} KB`;
}

/** A count as people read it: "1,000,000". */
export const countWords = (n: number) => n.toLocaleString("en-US");
